import booker from 'booker/resources'
import bot from 'maia/resources'

// eslint-disable-next-line 
export default {
   "es-mx": Object.assign({},
      booker['es-mx'],
      bot['es-mx']
   )
};
